import { Label } from "components/input/Label";
import DocumentoSolicitacaoRevisao from "model/documentos/DocumentoSolicitacaoRevisao";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import DocumentoSolicitacaoRevisaoService from "service/documentos/DocumentoSolicitacaoRevisaoService";
import { converterDataHora } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    solicitacao: DocumentoSolicitacaoRevisao
}

const service = new DocumentoSolicitacaoRevisaoService();
export default function ModalDocumentoVerSolicitacaoRevisao(props: Props) {

    return (
        <Dialog
            header="Responder solicitação de revisão"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
            </>}
        >
            <span style={{ fontWeight: 700 }}>Solicitação</span>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem', paddingLeft: '12px', paddingRight: '12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Usuário</Label>
                    <InputText readOnly value={props.solicitacao.usuarioSolicitacao?.nome || ""} style={{ width: '100%' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Data</Label>
                    <InputText readOnly value={converterDataHora(props.solicitacao.dataGeracao)} style={{ width: '100%' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Descrição</Label>
                    <InputTextarea rows={5} readOnly value={props.solicitacao.descricao} style={{ width: '100%' }} />
                </div>
            </div>
            {props.solicitacao.usuarioResposta ? <div style={{ borderTop: '1px solid #ccc', marginTop: '1rem', paddingTop: '1rem' }}>
                <span style={{ fontWeight: 700 }}>Resposta</span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '1rem', paddingLeft: '12px', paddingRight: '12px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                        <Label>Usuário</Label>
                        <InputText readOnly value={props.solicitacao.usuarioResposta?.nome || ""} style={{ width: '100%' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                        <Label>Data</Label>
                        <InputText readOnly value={converterDataHora(props.solicitacao.dataResposta)} style={{ width: '100%' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                        <Label>Resposta</Label>
                        <InputText readOnly value={service.getResposta(props.solicitacao.resposta)} style={{ width: '100%' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                        <Label>Motivo</Label>
                        <InputTextarea rows={5} readOnly value={props.solicitacao.observacaoResposta||""} style={{ width: '100%' }} />
                    </div>
                </div>
            </div> : null}



        </Dialog >
    );
}